import { createContext, useContext, type ReactNode } from 'react'
import { useFeatureIsOn } from '@growthbook/growthbook-react'
import { featureFlagKeys } from './feature-keys'

const HeadlessUiAnchorContext = createContext<boolean | null>(null)

export const HeadlessUiAnchorBridge = ({ children }: { children: ReactNode }): ReactNode => {
  const enabled = useFeatureIsOn(featureFlagKeys.enableHeadlessUiAnchor)

  return (
    <HeadlessUiAnchorContext.Provider value={enabled}>{children}</HeadlessUiAnchorContext.Provider>
  )
}

export const useHeadlessUiAnchor = (): boolean => useContext(HeadlessUiAnchorContext) ?? false
